import { FormInstance } from "antd"

import Schema from "./schema"

export const validateForm = (state: any, form: FormInstance, name: string) : boolean  => {
    const schema = Schema[name]
    let hasError = false;

    try {
       schema.validateSync(state)
        form.setFields([{
            name,
            errors: []
        }])
    
    } catch (error) {
        form.setFields([{
            name,
            errors: [error.message]
        }])
        hasError = true;
    }

    return hasError;
}
